import { Outlet, useLocation } from "react-router-dom";

import "./style.css";
import { Header, Footer } from "../organisms";

const Layout = () => {
  const location = useLocation();

  const hideFooterRoutes = ["/ai-agent-chat-bot"];
  const shouldShowFooter = !hideFooterRoutes.some((route) =>
    location.pathname.startsWith(route)
  );

  return (
    <div>
      <div className="h-[80px] lg:h-32">
        <Header />
      </div>
      <div className="content-container">
        <Outlet />
      </div>
      <div>{shouldShowFooter && <Footer />}</div>
    </div>
  );
};

export default Layout;
